
import React from 'react'
// import styled from 'styled-components'

// import { FixedSpaceColumn } from 'lib-components/layout/flex-helpers'
import type { CitizenCustomizations} from 'lib-customizations/types'

import { citizenConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'
import mapConfig from './mapConfig'
import { H1, H2, H3, P } from 'lib-components/typography'
import ExternalLink from 'lib-components/atoms/ExternalLink'
import colors from 'lib-customizations/common'

// const MultiLineCheckboxLabel = styled(FixedSpaceColumn).attrs({
//   spacing: 'zero'
// })`
//   margin-top: -6px;
// `

const customizations: CitizenCustomizations = {
  appConfig: citizenConfig,
  langs: ['fi', 'sv', 'en'],
  translations: {
    fi: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: '',
          en: 'English'
        },
      },
      calendar: {
        absentPlanned: 'Ennalta ilmoitettu poissaolo',
      },
      footer: {
        cityLabel: '© Kouvolan kaupunki',
        privacyPolicyLink: (
          <a
            href="https://www.kouvola.fi/kouvolankaupunki/asiointi/tietosuoja/tietosuojaselosteet/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Tietosuojaselosteet
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://kouvola.asiointi.fi/eFeedback"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Lähetä palautetta
          </a>
        ),
      },
      children: {
        serviceApplication: {
          startDateInfo:
            'Valitse päivä, jolloin haluaisit uuden palveluntarpeen alkavan. Palveluntarvetta voi vaihtaa vain kuukauden alusta. Jos muutoksen yhteydessä tulotiedot muuttuvat, kirjoita tieto alle ja tee uusi tuloselvitys.',
            additionalInfoInfo:
            'Kirjoita tähän lisätietoja esim. miksi haluat vaihtaa palveluntarvetta',
          },
      },
      loginPage: {
        title: 'Kouvolan kaupungin varhaiskasvatus',
        login: {
          infoBoxText: (
            <>
            <P>
              Mikäli kirjautuminen ei onnistu, voit olla yhteydessä sähköpostiosoitteeseen{' '}
              <a href="mailto:evakatuki@kouvola.fi">evakatuki@kouvola.fi</a>
              . Voit kirjautua myös käyttämällä vahvaa tunnistautumista.
            </P>
            </>
          ),
        },
      },
      applicationsList: {
         type: {
          DAYCARE: 'Varhaiskasvatushakemus',
          PRESCHOOL: 'Esiopetushakemus',
          CLUB: 'Kerhohakemus (ei käytössä Kouvolassa)'
        },
        title: 'Hakeminen varhaiskasvatukseen ja ilmoittautuminen esiopetukseen',
        summary: (
          <P width="800px">
            Lapsen huoltaja voi tehdä lapselle hakemuksen varhaiskasvatukseen tai
            ilmoittaa lapsen esiopetukseen. Samalla hakemuksella voi
            hakea myös varhaiskasvatuksen palveluseteliä, hakemalla
            varhaiskasvatuspaikkaa palveluseteliyksiköstä. Huoltajan lasten tiedot
            haetaan tähän näkymään automaattisesti Väestötietojärjestelmästä.
          </P>
        ),
      },
      map: {
        mainInfo:
          "Tässä näkymässä voit hakea kartalta Kouvolan varhaiskasvatus ja esiopetuspaikkoja.",
        serviceVoucherLink:
          'https://kouvola.asiointi.fi/IMS/fi?REQUEST=Search,P%E4iv%E4hoitopalvelut',
        privateUnitInfo: (
          <span>
            Tietoa päiväkodeista löydät{' '}
            <ExternalLink
              text="täältä."
              href="https://www.kouvola.fi/kasvu-ja-oppiminen/paivahoito-ja-varhaiskasvatus/paivakodit/"
              newTab
            />
          </span>
        ),
      },
      applications: {
        creation: {
          daycareInfo:
            'Varhaiskasvatushakemuksella haetaan kunnallista varhaiskasvatuspaikkaa päiväkotiin. Samalla hakemuksella voi hakea myös varhaiskasvatuksen palveluseteliä yksityiseen päiväkotiin ja perhepäivähoitoon.',
          preschoolInfo: (
            <>
              <P>
               Maksutonta esiopetusta on neljä tuntia päivässä. Tämän lisäksi lapselle voidaan hakea täydentävää maksullista varhaiskasvatusta, jota tarjotaan esiopetuspaikoissa aamulla ennen esiopetuksen alkua ja iltapäivisin esiopetuksen jälkeen.
               Täydentävään varhaiskasvatukseen voi hakea myös palveluseteliä valitsemalla Hakutoiveet -kohtassa palveluseteliyksikön, johon halutaan hakea.
               Hakemuksen täydentävään varhaiskasvatukseen voi tehdä esiopetukseen ilmoittautumisen yhteydessä tai erillisenä hakemuksena opetuksen jo alettua.
              </P>
            </>
          ) as unknown as string,
          transferApplicationInfo: {
            DAYCARE:
              'Lapsella on jo paikka Kouvolan varhaiskasvatuksessa. Tällä hakemuksella voit hakea siirtoa toiseen varhaiskasvatusta tarjoavaan yksikköön kouvolassa.',
          },
          applicationInfo: (
            <P>
              Hakemukseen voi tehdä muutoksia niin kauan kuin hakemusta ei ole otettu käsittelyyn eli hakemus on "lähetetty"-tilassa.
              Tämän jälkeen muutokset hakemukseen tehdään ottamalla yhteyttä varhaiskasvatuksen sähköpöstilla palveluohjaukseen varhaiskasvatus.palveluohjaus@kouvola.fi
              tai (puh. 0404831890, 0404832400 tai 0404899042). Voit perua jo tehdyn hakemuksen ilmoittamalla siitä sähköpostilla
            </P>
          )
        },
        editor: {
          additionalDetails: {
            title: 'Muut lisätiedot',
            otherInfoLabel: 'Hakuun liittyvät lisätiedot',
            otherInfoPlaceholder:
              'Voit halutessasi antaa hakuun liittyvää tarkempaa lisätietoa',
            dietLabel: 'Erityisruokavalio',
            dietPlaceholder: 'Voit halutessasi ilmoittaa lapsen erityisruokavalion',
            dietInfo: (
              <>
                Erityisruokavalioista tulee ilmoittaa sähköisellä tai paperilomakkeella. Terveydellisistä syistä
                oleva ruokavalio tulee olla terveydenhuollon toteama, mutta erillistä todistusta ei tarvitse
                toimittaa.
              </>
            ) as React.ReactNode,
            allergiesLabel: 'Allergiat',
            allergiesPlaceholder: 'Voit halutessasi ilmoittaa lapsen allergiat'
          },
          unitPreference: {
            siblingBasis: {
              info: {
                PRESCHOOL: (
                  <>
                    <P>Esioppilaalla on sisarusperuste:</P>
                    <ol>
                      <li>
                        Päiväkotiin, jossa esioppilaalla on
                        sisarus, jolla on päätöksentekohetkellä ja tulevana
                        esiopetusvuonna paikka esiopetuspäiväkodissa.
                      </li>
                    </ol>
                    <P>
                      Täytä nämä tiedot vain, jos käytät sisarusperustetta, sekä
                      valitse alla olevissa hakutoiveissa ensisijaiseksi toiveeksi
                      sama yksikkö, jossa lapsen sisarus on.
                    </P>
                  </>
                ),
              },
            },
            units: {
               serviceVoucherLink:
              'https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/yksityinen-varhaiskasvatus/varhaiskasvatuksen-palveluseteli/',
              info: {
                DAYCARE: (
                  <>
                    <P>
                      Voit hakea 1-3 paikkaa toivomassasi järjestyksessä.
                      Hakutoiveet eivät takaa paikkaa toivotussa yksikössä, mutta
                      mahdollisuus toivotun paikan saamiseen kasvaa antamalla
                      useamman vaihtoehdon.
                    </P>
                    <P>
                      Kunnallisen varhaiskasvatuksen asiakasmaksut ja palvelusetelin
                      omavastuuosuus määräytyvät prosenttiosuutena perheen
                      bruttotuloista. Tulojen lisäksi maksuihin vaikuttaa perheen koko
                      ja sovittu varhaiskasvatusaika. Perhe toimittaa tuloselvityksen
                      bruttotuloistaan, kun lapsi on aloittanut varhaiskasvatuksessa.

                      Näet eri varhaiskasvatusyksiköiden sijainnin valitsemalla
                      ‘Yksiköt kartalla’.
                    </P>
                    <P>
                      Lisätietoa varhaiskasvatuksen maksuista, tuloselvityksen
                      toimittamisesta ja palvelusetelin lisämaksusta löydät täältä:{' '}
                      <a href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/">
                        Maksut varhaiskasvatuksessa
                      </a>
                      .
                    </P>
                  </>
                ),
                PRESCHOOL: (
                  <>
                    <P>
                      Voit hakea 1-3 eri yksikköön toivomassasi järjestyksessä.
                      Hakutoiveet eivät takaa paikkaa toivotusta yksiköstä, mutta
                      mahdollisuus toivotun paikan saamiseen kasvaa antamalla
                      useamman vaitoehdon.
                    </P>
                    <P>
                      Näet eri yksiköiden sijainnin valitsemalla ‘Yksiköt kartalla’.
                    </P>
                    <P>
                      Jos haette yksityiseen palvelusetelipäiväkotiin, saatte palvelusetelipäätöksen.
                      Palvelusetelin vastaanottamis- tai kieltäytymisilmoitus tulee hyväksyä/hylätä viimeistään
                      kahden viikon kuluessa. Tämän jälkeen teidän tulee ottaa itse yhteyttä haluamaanne
                      palvelusetelipäiväkotiin sopiaksenne hoitopaikasta. Jos hoitopaikka järjestyy
                      palvelusetelipäiväkodista, teette palvelusopimuksen yhteistyössä päiväkodin kanssa.
                      Palvelusopimus yksityisen palveluntuottajan kanssa tehdään kyseisessä yksikössä ja se
                      aktivoi palvelusetelin käytön.
                      Jos ette saa paikkaa yksityisestä päiväkodista, tulee teidän hakea varhaiskasvatuspaikkaa
                      uudella varhaiskasvatushakemuksella. Tällöin hakuaika on neljä (4) kuukautta
                      (varhaiskasvatuslaki 17 §).
                    </P>
                    <P>
                      Kirjaa alle lisätietoja kenttään mahdollinen toive metsäeskariin pääsystä
                      sekä tarvittaessa muuta lisätietoa.
                    </P>
                  </>
                ),
              },
            },
          },
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    Varhaiskasvatusta voi hakea ympäri vuoden. Hakemus on jätettävä
                    viimeistään neljä kuukautta ennen kuin tarvitsette paikan.
                    Mikäli tarvitsette varhaiskasvatusta kiireellisesti työn tai
                    opiskelujen vuoksi, tulee paikkaa hakea viimeistään kaksi
                    viikkoa ennen.
                  </P>
                  <P>
                    Saatte kirjallisen päätöksen varhaiskasvatuspaikasta{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P>
                    Kunnallisen varhaiskasvatuksen asiakasmaksut ja palvelusetelin
                    omavastuuosuus määräytyvät prosenttiosuutena perheen
                    bruttotuloista. Tulojen lisäksi maksuihin vaikuttaa perheen koko
                    ja sovittu varhaiskasvatusaika. Palveluseteliyksiköissä voidaan
                    periä lisämaksu, tiedot mahdollisesta lisämaksusta löytyy
                    yksikön nettisivuilta. Perhe toimittaa tuloselvityksen
                    bruttotuloistaan viimeistään kahden viikon kuluessa siitä, kun
                    lapsi on aloittanut varhaiskasvatuksessa.
                  </P>
                  <P>
                    Lisätietoa varhaiskasvatuksen maksuista, tuloselvityksen
                    toimittamisesta ja palvelusetelin lisämaksusta löydät täältä:{' '}
                    <a href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/">
                      Maksut varhaiskasvatuksessa
                    </a>
                    {' '}ja{' '}
                    <a href="https://www.kouvola.fi/kasvu-ja-oppiminen/paivahoito-ja-varhaiskasvatus/palvelusetelipaivakotihoidossa/">
                      lisätietoa palvelusetelistä
                    </a>
                    .
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                  Esiopetukseen osallistutaan oppivelvollisuuden alkamista edeltävänä vuonna.
                  Esiopetus on maksutonta. Esiopetusta täydentävään varhaiskasvatukseen lasketaan
                  ainoastaan täydentävän varhaiskasvatuksen aika eli 4h päivässä olevaa esiopetusta
                  ei tarvitse laskea palveluntarpeeseen. {' '}
                    <a href="https://www.kouvola.fi/kasvu-ja-oppiminen/esiopetus/">
                      Lisätietoa esiopetuksesta.
                    </a>
                  </P>
                  <P>
                    Päätökset tulevat{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi
                    -palvelua käyttöön.
                  </P>
                  <P>
                    Jos tarvitsette varhaiskasvatusta ennen esiopetuksen alkua, voitte hakea sitä tällä hakemuksella valitsemalla ”Haen myös esiopetukseen liittyvää varhaiskasvatusta”.
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              CLUB: (
                <>
                  <P>
                    Leikkikerhotoimintaan haetaan sähköisesti varhaiskasvatushakemuksella.
                    Leikkikerhohakemukseen valitaan hoitomuodoksi osapäivähoito ja lisätietoihin kirjoitetaan,
                    että haetaan leikkikerhotoimintaan.
                  </P>
                  <P>
                    Leikkikerhomaksu määräytyy kuten varhaiskasvatuksen asiakasmaksu.
                    Leikkikerhomaksu on 17% kokoaikaisesta varhaiskasvatusmaksusta.
                  </P>
                  <P>
                    Leikkikerhojen toimintakausi on syyskuun alusta toukokuun loppuun.
                    Lapsi voi aloittaa kerhossa aikaisintaan sen kuukauden aikana, jolloin hän täyttää kolme vuotta.
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              )
            },
          },
          actions: {
            allowOtherGuardianAccess: (
              <span>
                Ymmärrän, että tieto hakemuksesta menee myös lapsen toiselle
                huoltajalle. Jos tieto ei saa mennä toiselle huoltajalle, ole
                yhteydessä palveluohjaukseen. Palveluohjauksen yhteystiedot löydät{' '}
                <a
                  href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatukseen-esiopetukseen-hakeminen/"
                  target="_blank"
                  rel="noreferrer"
                >
                  täältä
                </a>
                .
              </span>
            ),
          },
          serviceNeed: {
            shiftCare: {
              label: 'Ilta- ja vuorohoito',
              instructions:
                'Vuorohoidolla tarkoitetaan viikonloppuna tai ympärivuorokautisesti tarvittavaa varhaiskasvatusta. Iltahoito on pääasiassa klo 7:00-17.00 ulkopuolella ja viikonloppuisin tapahtuvaa varhaiskasvatusta.',
              attachmentsMessage: {
                DAYCARE: (
                  <P>
                    Ilta- ja vuorohoito on tarkoitettu lapsille, joiden molemmat
                    vanhemmat ovat vuorotyössä tai opiskelevat pääsääntöisesti
                    iltaisin ja/tai viikonloppuisin. Hakemuksen liitteeksi
                    toimitetaan molempien vanhempien osalta työnantajan todistus
                    vuorotyöstä tai opiskelusta johtuvasta ilta- tai vuorohoidon
                    tarpeesta. Jos et voi lisätä liitteitä hakemukselle sähköisesti,
                    voit tuoda ne mihin tahansa päiväkotiin, kaupungintalon info-pisteeseen
                    tai H-ovessa sijaitsevaan postilaatikkoon (osoite: Torikatu 10, 45100 Kouvola).
                  </P>
                ),
                PRESCHOOL: (
                  <>
                    <P>
                      Esiopetushakemukselle pyydämme liittämään samassa taloudessa
                      asuvien huoltajien osalta todistukset työnantajalta
                      säännöllisestä vuorotyöstä tai oppilaitoksen edustajalta
                      päätoimisesta iltaopiskelusta. Dokumenttien tulee olla
                      kirjattu sinä vuonna, kun hakemus esiopetukseen tehdään.
                    </P>
                    <P>
                      Ilta- ja vuorohoito on tarkoitettu lapsille, joiden molemmat
                      vanhemmat ovat vuorotyössä tai opiskelevat pääsääntöisesti
                      iltaisin ja/tai viikonloppuisin. Hakemuksen liitteeksi
                      toimitetaan molempien vanhempien osalta työnantajan todistus
                      vuorotyöstä tai opiskelusta johtuvasta ilta- tai vuorohoidon
                      tarpeesta. Jos et voi lisätä liitteitä hakemukselle sähköisesti,
                      voit tuoda ne mihin tahansa päiväkotiin, kaupungintalon info-pisteeseen
                      tai H-ovessa sijaitsevaan postilaatikkoon (osoite: Torikatu 10, 45100 Kouvola).
                    </P>
                  </>
                )
              },
            },
            partTime: {
              true: 'Osa-aikainen',
              false: 'Kokoaikainen'
            },
            startDate: {
              instructions: {
                DAYCARE: (
                  <>
                    Toivottua aloituspäivää on mahdollista muuttaa niin
                    kauan kuin hakemusta ei ole otettu käsittelyyn. Tämän jälkeen
                    toivotun aloituspäivän muutokset tehdään ottamalla yhteyttä
                    varhaiskasvatuksen palveluohjaukseen varhaiskasvatus.palveluohjaus@kouvola.fi
                    tai puhelimitse (puh. 0404831890, 0404832400 tai 0404899042).
                  </>
                ),
                PRESCHOOL: (
                  <>
                    Toivottua aloituspäivää on mahdollista muuttaa niin
                    kauan kuin hakemusta ei ole otettu käsittelyyn. Tämän jälkeen
                    toivotun aloituspäivän muutokset tehdään ottamalla yhteyttä
                    varhaiskasvatuksen palveluohjaukseen varhaiskasvatus.palveluohjaus@kouvola.fi
                    tai puhelimitse (puh. 0404831890, 0404832400 tai 0404899042).
                  </>
                ),
                CLUB: null
              } as {
                DAYCARE: React.JSX.Element | null
                PRESCHOOL: React.JSX.Element | null
                CLUB: React.JSX.Element | null
              },
              info: {
                PRESCHOOL: [
                  '',
                ],
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <>
                    <P fitted={true}>
                      Jos tarvitset varhaiskasvatuspaikkaa äkillisen työllistymisen tai opiskelun
                      vuoksi, hae paikkaa viimeistään kaksi viikkoa ennen tarpeen alkamista.
                      Voit liittää hakemukseen työ- tai opiskelutodistukset samassa taloudessa
                      asuvilta huoltajilta. Suosittelemme toimittamaan liitteet sähköisesti.

                      Suosittelemme toimittamaan liitteen sähköisesti tässä, sillä
                      kahden viikon käsittelyaika alkaa siitä, kun olemme
                      vastaanottaneet hakemuksen tarvittavine liitteineen.
                      Jos et voi lisätä liitteitä hakemukselle sähköisesti,
                      voit tuoda ne mihin tahansa päiväkotiin, kaupungintalon
                      info-pisteeseen tai H-ovessa sijaitsevaan postilaatikkoon
                      (osoite: Torikatu 10, 45100 Kouvola).
                    </P>
                  </>
                ),
              }
            },
            dailyTime: {
              instructions: {
                DAYCARE:
                  'Ilmoita lapsen yleisimmin tarvitseva varhaiskasvatusaika, aika tarkennetaan varhaiskasvatuksen alkaessa.',
                PRESCHOOL:
                  'Esiopetusta tarjotaan sekä päiväkodeissa että kouluissa 4 tuntia päivässä. Ilmoita lapsen tarvitsema varhaiskasvatusaika siten, että se sisältää esiopetusajan 4 h (esim. 7.00 – 17.00). Aika tarkennetaan varhaiskasvatuksen alkaessa. Varhaiskasvatustarpeen ajan vaihdellessa päivittäin tai viikoittain (esim. vuorohoidossa), ilmoita tarve tarkemmin lisätiedoissa lomakkeen lopussa.'
              },
              connectedDaycareInfo: (
                <>
                  <P>
                    Voit hakea lapselle tarvittaessa esiopetukseen täydentävää varhaiskasvatusta, joka on maksullista.
                    Täydentävää varhaiskasvatusta järjestetään aamuisin ennen esiopetusta ja esiopetuksen jälkeen esiopetusyksikön
                    aukioloaikojen mukaisesti.
                  </P>
                  <P>
                    Saat varhaiskasvatuspaikasta erillisen kirjallisen päätöksen.
                    Päätös tulee{' '}
                    <a
                      href="https://www.suomi.fi/viestit"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi-viestit
                    </a>{' '}
                    -palveluun tai postitse, mikäli et ole ottanut Suomi.fi-viestit
                    -palvelua käyttöön.
                  </P>
                </>
              ),
            },
          },
          fee: {
            links: (
              <>
              <P>
                Lisätietoa varhaiskasvatuksen maksuista, palvelusetelin lisämaksusta
                ja tuloselvityslomakkeen löydät täältä:
                <br />
                <a
                  href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Maksut varhaiskasvatuksessa
                </a>
              </P>
              <P>
                <a
                  href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/yksityinen-varhaiskasvatus/varhaiskasvatuksen-palveluseteli/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Lisätietoa palvelusetelistä
                </a>
              </P>
              </>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "Kouvolan varhaiskasvatuksessa virallisena osoitteena pidetään väestötiedoista saatavaa osoitetta. Osoite väestötiedoissa muuttuu hakijan tehdessä muuttoilmoituksen postiin tai maistraattiin.",
          },
        },
      },
      decisions: {
        assistancePreschoolDecisions: {
          appealInstructions: (
            <>
              <P>
                Tähän päätökseen tyytymätön voi tehdä kirjallisen
                oikaisuvaatimuksen. Päätökseen ei saa hakea muutosta valittamalla
                tuomioistuimeen.
              </P>

              <H3>Oikaisuvaatimusoikeus</H3>
              <P>
                Oikaisuvaatimuksen saa tehdä se, johon päätös on kohdistettu tai
                jonka oikeuteen, velvollisuuteen tai etuun päätös välittömästi
                vaikuttaa (asianosainen).
              </P>

              <H3>Oikaisuvaatimusaika</H3>
              <P>
                Oikaisuvaatimus on tehtävä 30 päivän kuluessa päätöksen
                tiedoksisaannista.
              </P>
              <P>
                Oikaisuvaatimus on toimitettava Kouvolan kunnan
                kirjaamoon määräajan viimeisenä päivänä ennen kirjaamon aukioloajan
                päättymistä.
              </P>
              <P>
                Asianosaisen katsotaan saaneen päätöksestä tiedon, jollei
                muuta näytetä, seitsemän (7) päivän kuluttua kirjeen lähettämisestä.
              </P>
              <P>
                Käytettäessä tavallista sähköistä tiedoksiantoa katsotaan asianosaisen
                saaneen tiedon päätöksestä kolmantena päivänä viestin lähettämisestä.
                Tiedoksisaantipäivää ei lueta oikaisuvaatimusaikaan.
              </P>
              <P>
                Jos
                oikaisuvaatimusajan viimeinen päivä on pyhäpäivä, itsenäisyyspäivä,
                vapunpäivä, joulu- tai juhannusaatto tai arkilauantai, saa
                oikaisuvaatimuksen tehdä ensimmäisenä arkipäivänä sen jälkeen.
              </P>

              <H3>Oikaisuviranomainen</H3>
              <P>
                Viranomainen, jolle oikaisuvaatimus tehdään, on Kouvolan kaupungin
                sivistyslautakunta (varhaiskasvatuslain 50 §:ssä tarkoitettu kunnan
                monijäseninen toimielin)
              </P>
              <P>
                Kirjaamon yhteystiedot:
                <br />
                Postiosoite: PL 133, 87101 kouvola
                <br />
                Käyntiosoite: Pohjolankatu 13, 87100 kouvola
                <br />
                Sähköpostiosoite: kouvola@kouvola.fi
                <br />
                Puhelinnumero: 08 61551
                <br />
                  Kirjaamon aukioloaika on maanantaista torstaihin klo 8.00-16.00.
                  Perjantaisin tai juhlapyhien aattoina 9.00-15.00.
              </P>
              <H3>Oikaisuvaatimuksen muoto ja sisältö</H3>
              <P>
                Oikaisuvaatimus on tehtävä kirjallisesti. Myös sähköinen asiakirja
                täyttää vaatimuksen kirjallisesta muodosta.
              </P>
              <P noMargin>
                Oikaisuvaatimuksessa, joka on
                osoitettava Kouvolan kaupungin sivistyslautakunnalle, on ilmoitettava:
              </P>
              <ul>
                <li>päätös, johon vaaditaan oikaisua,</li>
                <li>millaista oikaisua päätökseen vaaditaan,</li>
                <li>millä perusteilla oikaisua vaaditaan</li>
              </ul>
              <P>
                Oikaisuvaatimuksessa on lisäksi ilmoitettava tekijän nimi, postiosoite,
                puhelinnumero ja muut asian hoitamiseksi tarvittavat yhteystiedot.
              </P>
              <P>
                Jos oikaisuvaatimuspäätös voidaan antaa tiedoksi sähköisenä viestinä,
                yhteystietona pyydetään ilmoittamaan myös sähköpostiosoite.
              </P>
              <P>
                Jos oikaisuvaatimuksen tekijän puhevaltaa käyttää hänen laillinen
                edustajansa tai asiamiehensä tai jos oikaisuvaatimuksen laatijana on joku
                muu henkilö, oikaisuvaatimuksessa on ilmoitettava myös tämän
                yhteystiedot.
              </P>
              <P noMargin>Oikaisuvaatimukseen on liitettävä</P>
              <ul>
                <li>
                  oikaisuvaatimuksen kohteena oleva päätös (alkuperäisenä tai
                  jäljennöksenä) oikaisuvaatimusohjeineen
                </li>
                <li>
                  selvitys siitä, milloin oikaisuvaatimuksentekijä on saanut päätöksen
                  tiedoksi, tai muu selvitys oikaisuvaatimusajan alkamisesta
                </li>
                <li>
                  asiakirjat, joihin oikaisuvaatimuksen tekijä vetoaa, jollei niitä ole jo
                  aikaisemmin toimitettu viranomaiselle.
                </li>
              </ul>
              <P>
                Asianosaiselle lähetettäviin oikaisuvaatimusohjeisiin merkitään
                lähettämispäivä:
              </P>
              <P>
                Päätös on annettu asianosaiselle tiedoksi kirjeellä, joka on lähetetty.
                Päätös on annettu asianosaiselle tiedoksi sähköisenä tiedoksiantona, joka
                on lähetetty
              </P>
            </>
          )
        },
        assistanceDecisions: {
          decision: {
            appealInstructions: (
              <>
                <H3>Oikaisuvaatimusoikeus</H3>
                <P>
                  Oikaisuvaatimuksen saa tehdä se, johon päätös on kohdistettu tai jonka
                  oikeuteen, velvollisuuteen tai etuun päätös välittömästi vaikuttaa
                  (asianosainen).
                </P>
                <H3>Oikaisuvaatimusaika</H3>
                <P>
                  Oikaisuvaatimus on tehtävä 14 päivän kuluessa päätöksen
                  tiedoksisaannista. Oikaisuvaatimus on toimitettava Pohjois-Suomen aluehallintovirastolle
                  viimeistään määräajan viimeisenä päivänä ennen aluehallintoviraston
                  aukioloajan päättymistä.
                </P>
                <H3>Tiedoksisaanti</H3>
                <P>
                  Asianosaisen katsotaan saaneen päätöksestä tiedon, jollei muuta näytetä,
                  seitsemän päivän kuluttua kirjeen lähettämisestä. Käytettäessä tavallista
                  sähköistä tiedoksiantoa katsotaan asianosaisen saaneen tiedon
                  päätöksestä kolmantena päivänä viestin lähettämisestä. Tiedoksisaantipäivää
                </P>
                <P>
                  Tiedoksisaantipäivää ei lueta oikaisuvaatimusaikaan. Jos
                  oikaisuv aatimusajan viimeinen päivä on pyhäpäivä, itsenäisyyspäivä,
                  vapunpäivä, joulu- tai juhannusaatto tai arkilauantai, saa
                  oikaisuvaatimuksen tehdä ensimmäisenä arkipäivänä sen jälkeen.
                </P>
                <H3>Oikaisuviranomainen</H3>
                <P>Oikaisuvaatimus tehdään Pohjois-Suomen aluehallintovirastolle.</P>
                <P>
                  Sähköinen oikaisuvaatimus voidaan laatia
                   <a href='https://www.suomi.fi/palvelut/verkkoasiointi/oikaisuvaatimus-
                  varhaiskasvatus-opetus-ja-koulutus-aluehallintovirasto/d7022cad-
                  9ecd-4dad-84ec-17489d260a8d'>Suomi.fi-palvelussa</a>
                  <br />
                  Kirjallinen oikaisuvaatimus toimitetaan:
                  <br />
                  Postiosoite:  PL 6, 13035 AVI
                  <br />
                  Käyntiosoite: Linnankatu 3, Oulu
                  <br />
                  Sähköpostiosoite: kirjaamo.pohjois@avi.fi
                  <br />
                  Puhelinnumero: 0295 016 000
                  <br />
                  Kirjaamon aukioloaika: klo 8.00–16.15
                </P>
                <H3>Oikaisuvaatimuksen muoto ja sisältö</H3>
                <P>
                  Oikaisuvaatimus on tehtävä kirjallisesti. Myös sähköinen asiakirja
                  täyttää vaatimuksen kirjallisesta muodosta.
                </P>
                <P noMargin>
                  Oikaisuvaatimuksessa, joka on osoitettava valitusviranomaiselle, on
                  ilmoitettava:
                </P>
                <ul>
                  <li>päätös, johon vaaditaan oikaisua</li>
                  <li>
                    miltä kohdin päätökseen haetaan oikaisua ja millaista oikaisua
                    siihen vaaditaan tehtäväksi
                  </li>
                  <li>millä perusteella oikaisua vaaditaan.</li>
                </ul>
                <P>
                  Oikaisuvaatimuksessa on ilmoitettava tekijän nimi, postiosoite,
                  puhelinnumero ja muut asian hoitamiseksi tarvittavat yhteystiedot.
                </P>
                <P>
                  Jos oikaisuvaatimusviranomaisen päätös voidaan antaa tiedoksi
                  sähköisenä viestinä, yhteystietona pyydetään ilmoittamaan myös
                  sähköpostiosoite.
                </P>
                <P>
                  Jos oikaisuvaatimuksen tekijän puhevaltaa käyttää hänen laillinen
                  edustajansa tai asiamiehensä tai jos oikaisuvaatimuksen laatijana on joku
                  muu henkilö, oikaisuvaatimuksessa on ilmoitettava myös tämän
                  yhteystiedot.
                </P>
                <P>
                  Jos oikaisuvaatimusviranomaisen päätös voidaan antaa tiedoksi
                  sähköisenä viestinä, yhteystietona pyydetään ilmoittamaan myös
                  sähköpostiosoite.
                </P>
                <P>
                  Oikaisuvaatimuksen tekijän, laillisen edustajan tai asiamiehen on
                  allekirjoitettava oikaisuvaatimus. Sähköistä asiakirjaa ei kuitenkaan tarvitse
                  täydentää allekirjoituksella, jos asiakirjassa on tiedot lähettäjästä eikä
                  asiakirjan alkuperäisyyttä tai eheyttä ole syytä epäillä.
                </P>
                <P noMargin>Oikaisuvaatimukseen on liitettävä</P>
                <ul>
                  <li>
                    päätös, johon haetaan oikaisua, alkuperäisenä tai jäljennöksenä
                    oikaisuvaatimusohjeineen
                  </li>
                  <li>
                    selvitys siitä, milloin oikaisuvaatimuksentekijä on saanyt päätöksen
                    tiedoksi, tai muu selvitys oikaisuvaatimusajan alkamisesta
                  </li>
                  <li>
                    asiakirjat, joihin oikaisuvaatimuksen tekijä vetoaa, jollei niitä ole jo
                    aikaisemmin toimitettu viranomaiselle.
                  </li>
                </ul>
                <H3>Pöytäkirja</H3>
                <P>
                  Päätöstä koskevia pöytäkirjan otteita ja liitteitä voi pyytää Kouvolan
                  kaupungin kirjaamosta.
                  <br />
                  Postiosoite: PL 133, 87101 kouvola
                  <br />
                  Käyntiosoite: Pohjolankatu 13, kouvola
                  <br />
                  Sähköpostiosoite: kouvola@kouvola.fi
                  <br />
                  Puhelinnumero: 08 61551 (vaihde)
                  <br />
                    Kunnan kirjaamon aukioloaika: klo 9.00–16.00; perjantaisin ja
                    juhlapyhien aattoina klo 8.00–15.00.
                </P>
              </>
            )
          },
        }
      },
      income: {
        description: (
          <>
            <P>
              Tällä sivulla voit lähettää tuloselvityksen varhaiskasvatusmaksuun vaikuttavista omista ja lastesi
              tuloista. Voit myös tarkastella palauttamiasi tuloselvityksiä ja muokata tai poistaa niitä, kunnes
              tuloselvitys on käsitelty varhaiskasvatuksessa. Lomakkeen käsittelyn jälkeen voit päivittää
              tulotietojasi toimittamalla uuden lomakkeen.
            </P>
            <P>
              Varhaiskasvatuksen asiakasmaksut määräytyvät prosenttiosuutena perheen bruttotuloista.
              Maksut vaihtelevat perheen koon ja tulojen sekä varhaiskasvatusajan mukaan. Maksun
              määräämistä varten tulee toimittaa perheen tulotiedot viimeistään kuukauden kuluttua
              varhaiskasvatuksen alkamisesta. Mikäli perhe ei toimita tuloselvitystä, maksuksi määrätään
              enimmäismaksu.
            </P>
            <P>
              Voit tarkistaa osoitteesta kouvola.fi/varhaiskasvatusmaksut, kuuluuko perheenne korkeimman
              varhaiskasvatusmaksun piiriin. Korkeimman maksun voitte käydä hyväksymässä
              tuloselvityksessä.

              Lisätietoja maksuista:{' '}
              <a href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/">
                Maksut varhaiskasvatuksessa
              </a>
            </P>
         </>
        ),
        formDescription: (
          <>
            <P>
              Tuloselvitys liitteineen palautetaan kuukauden kuluessa varhaiskasvatuksen aloittamisesta. Maksu voidaan määrätä puutteellisilla tulotiedoilla korkeimpaan maksuun.
              Puutteellisia tulotietoja ei korjata takautuvasti oikaisuvaatimusajan jälkeen. Asiakasmaksu peritään päätöksen mukaisesta varhaiskasvatuksen alkamispäivästä lähtien.
              Asiakkaan on viipymättä ilmoitettava tulojen muutoksista varhaiskasvatuksen hallintosihteerille ja perhekoon muutoksista varhaiskasvatusyksikköön. Viranomainen on tarvittaessa oikeutettu perimään varhaiskasvatusmaksuja myös takautuvasti.

              Huomioitavaa:
              Jos tulosi ylittävät perhekoon mukaisen korkeimman maksun tulorajan, hyväksy korkein varhaiskasvatusmaksu. Tällöin sinun ei tarvitse selvittää tulojasi lainkaan.
              Jos perheeseesi kuuluu toinen aikuinen, myös hänen on toimitettava tuloselvitys tunnistautumalla eVakaan omilla henkilötiedoillaan ja täyttämällä tämä lomake.
              Voit myös halutessasi ilmoittaa molempien perheen aikuisten tulot. Tässä tapauksessa hallintosihteeri merkitsee tulotiedot ohjelmaan toisen huoltajan puolesta. Tuloselvitys tulee toimittaa itse ja tulot tarkistetaan tarvittaessa tulorekisteristä.
              Katso voimassaolevat tulorajat {' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/"
              >
                tästä
              </a>
              .
            </P>
            <P>* Tähdellä merkityt tiedot ovat pakollisia</P>
          </>
        ),
        assure: <>Vakuutan antamani tiedot oikeiksi ja olen tutustunut Kouvolan kaupungin maksunmääräytymisperusteisiin: kouvola.fi/varhaiskasvatusmaksut *</>,
        grossIncome: {
          estimatedMonthlyIncome:
            'Keskimääräiset tulot sisältäen lomarahat, €/kk. Oma arvio ei riitä, lisää todistus tuloista liitteisiin.',
          description: (
            <>
              <P noMargin>
                Valitse alta haluatko toimittaa tulotietosi liitteinä, vai katsooko
                viranomainen tietosi suoraan tulorekisteristä sekä Kelasta
                tarvittaessa. Jos haluat kieltää tulorekisterin käytön, kirjoita tieto lisätiedot kohtaan.
              </P>
            </>
          ),
          incomesRegisterConsent:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tulorekisteristä sekä Kelasta tarvittaessa',
          noIncome:
            'Minulla ei ole mitään tuloja tai tukia. Tietoni saa tarkastaa tulorekisteristä sekä Kelasta',
        },
        entrepreneurIncome: {
          checkupConsent:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tulorekisteristä sekä Kelasta tarvittaessa',
        },
        limitedCompany: {
          incomesRegister:
          'Tuloni voi tarkastaa tarvittaessa tulorekisteristä sekä Kelasta',
        },
        view: {
          incomesRegister:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tulorekisteristä sekä Kelasta tarvittaessa',
           noIncomeTitle:
            'Minulla ei ole mitään tuloja tai tukia. Tietoni saa tarkastaa tulorekisteristä sekä Kelasta',
          checkupConsent:
            'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tulorekisteristä sekä Kelasta tarvittaessa',
          limitedCompanyIncomesRegister:
            'Tuloni voi tarkastaa Kelasta tai tulorekisteristä tarvittaessa.',
        }
      },
      accessibilityStatement: (
        <>
          <H1>Saavutettavuusseloste</H1>
          <P>
            Tämä saavutettavuusseloste koskee Kouvolan kaupungin varhaiskasvatuksen
            eVaka-verkkopalvelua osoitteessa{' '}
            <a href="https://varhaiskasvatus.kouvola.fi">varhaiskasvatus.kouvola.fi</a>.
            Kouvolan kaupunki pyrkii takaamaan verkkopalvelun saavutettavuuden,
            parantamaan käyttäjäkokemusta jatkuvasti ja soveltamaan asianmukaisia
            saavutettavuusstandardeja.
          </P>
          <P>
            Palvelun saavutettavuuden on arvioinut palvelun kehitystiimi, ja seloste
            on laadittu 20.11.2025.
          </P>
          <H2>Palvelun vaatimustenmukaisuus</H2>
          <P>
            Verkkopalvelu täyttää lain asettamat kriittiset
            saavutettavuusvaatimukset WCAG v2.1 -tason AA mukaisesti. Palvelu ei ole
            vielä kaikilta osin vaatimusten mukainen.
          </P>
          <H2>Toimet saavutettavuuden tukemiseksi</H2>
          <P>
            Verkkopalvelun saavutettavuus varmistetaan muun muassa seuraavilla
            toimenpiteillä:
          </P>
          <ul>
            <li>
              Saavutettavuus huomioidaan alusta lähtien suunnitteluvaiheessa, mm.
              valitsemalla palvelun värit ja kirjaisinten koot saavutettavasti.
            </li>
            <li>
              Palvelun elementit on määritelty semantiikaltaan johdonmukaisesti.
            </li>
            <li>Palvelua testataan jatkuvasti ruudunlukijalla.</li>
            <li>
              Erilaiset käyttäjät testaavat palvelua ja antavat saavutettavuudesta
              palautetta.
            </li>
            <li>
              Sivuston saavutettavuudesta huolehditaan jatkuvalla valvonnalla
              tekniikan tai sisällön muuttuessa.
            </li>
          </ul>
          <P>
            Tätä selostetta päivitetään sivuston muutosten ja saavutettavuuden
            tarkistusten yhteydessä.
          </P>
          <H2>Tunnetut saavutettavuusongelmat</H2>
          <P>
            Käyttäjät saattavat edelleen kohdata sivustolla joitakin ongelmia.
            Seuraavassa on kuvaus tunnetuista saavutettavuusongelmista. Jos huomaat
            sivustolla ongelman, joka ei ole luettelossa, otathan meihin yhteyttä.
          </P>
          <ul>
            <li>
              Palvelun päivämäärävalitsinta ja monivalintojen alasvetovalikkoa ei
              ole optimoitu käytettäväksi ruudunlukijalla.
            </li>
            <li>
              Palvelun yksikkökartassa ei pysty liikkumaan
              näppäimistöllä/ruudunlukijalla, mutta yksikköjä voi selata samassa
              näkymässä olevalta listalta. Palvelussa käytetty kartta on kolmannen
              osapuolen tuottama.
            </li>
          </ul>
          <H2>Kolmannet osapuolet</H2>
          <P>
            Verkkopalvelussa käytetään seuraavia kolmannen osapuolen palveluita,
            joiden saavutettavuudesta emme voi vastata.
          </P>
          <ul>
            <li>Suomi.fi-tunnistautuminen</li>
            <li>Leaflet-karttapalvelu</li>
          </ul>
          <H2>Vaihtoehtoiset asiointitavat</H2>
          <P>
            Kouvolan kaupungin asiointipisteistä saa apua sähköiseen asiointiin.
            Asiointipisteiden palveluneuvojat auttavat käyttäjiä, joille digipalvelut eivät ole saavutettavissa.
            Voit asioida Kouvolan kaupungin osoitteessa:
           <ExternalLink
              href="https://www.kouvola.fi/kouvolankaupunki/asiointi/toimipisteet/"
              text=" www.kouvola.fi/kouvolankaupunki/asiointi/toimipisteet/ "
            />
            tai sähköpostitse varhaiskasvatus.palveluohjaus@kouvola.fi
          </P>
          <H2>Anna palautetta</H2>
          <P>
           Jos huomaat saavutettavuuspuutteen verkkopalvelussamme, kerro siitä meille. Voit antaa palautetta:
           <ExternalLink
              href="https://kouvola.asiointi.fi/eFeedback/fi/Feedback/35-Saavutettavuus"
              text=" verkkolomakkeella "
            />
             tai sähköpostitse palaute@kouvola.fi
          </P>
          <H2>Valvontaviranomainen</H2>
          <P>
           Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta sivuston ylläpitäjälle.
           Vastauksessa voi mennä 14 päivää. Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta lainkaan
           kahden viikon aikana, voit antaa palautteen Liikenne- ja viestintävirasto Traficomille.
           Traficomin sivulla kerrotaan tarkasti, miten valituksen voi tehdä ja miten asia käsitellään.
          </P>
          <P>
            <strong>Valvontaviranomaisen yhteystiedot </strong>
            <br />
            Liikenne- ja viestintävirasto Traficom Digitaalisen esteettömyyden ja saavutettavuuden valvontayksikkö
            <br />
            https://www.saavutettavuusvaatimukset.fi/fi
            <br />
            saavutettavuus(at)traficom.fi
            <br />
            puhelinnumero vaihde 029 534 5000
          </P>
        </>
      ),
    },
    sv: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: '',
          en: 'English'
        },
      },
      calendar: {
        absentPlanned: 'På förhand anmäld frånvaro',
      },
      footer: {
        cityLabel: '© Kouvola stad',
        privacyPolicyLink: (
          <a
            href="https://www.kouvola.fi/kouvolankaupunki/asiointi/tietosuoja/tietosuojaselosteet/"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Dataskyddsbeskrivningar
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://kouvola.asiointi.fi/eFeedback"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Ge feedback
          </a>
        ),
      },
      children: {
        serviceApplication: {
          startDateInfo:
            'Välj den dag då du önskar att det nya servicebehovet ska börja. Servicebehovet kan endast ändras från början av en månad. Om inkomstuppgifterna ändras i samband med ändringen, skriv informationen nedan och lämna in en ny inkomstutredning.',
          additionalInfoInfo:
            'Skriv ytterligare information här, till exempel varför du vill ändra servicebehovet',
        },
      },
      loginPage: {
        title: 'Kouvola stads småbarnspedagogik',
        login: {
          infoBoxText: (
            <>
              <P>
                Om inloggningen inte lyckas kan du kontakta oss på e-postadressen{' '}
                <a href="mailto:evakatuki@kouvola.fi">evakatuki@kouvola.fi</a>
                . Du kan också logga in med stark autentisering.
              </P>
            </>
          ),
        },
      },
      applicationsList: {
        type: {
          DAYCARE: 'Ansökan om småbarnspedagogik',
          PRESCHOOL: 'Anmälan till förskoleundervisning',
          CLUB: 'Klubbansökan (används inte i Kouvola)'
        },
        title:
          'Ansökan till småbarnspedagogik och anmälan till förskoleundervisning',
        summary: (
          <P width="800px">
            Barnets vårdnadshavare kan ansöka om småbarnspedagogik för barnet
            eller anmäla barnet till förskoleundervisning. Med samma ansökan kan
            man också ansöka om servicesedel för småbarnspedagogik genom att söka
            en plats vid en servicesedelenhet. Uppgifterna om vårdnadshavarens
            barn hämtas automatiskt från befolkningsdatasystemet.
          </P>
        ),
      },
      map: {
        mainInfo:
          'I den här vyn kan du på kartan söka platser för småbarnspedagogik och förskoleundervisning i Kouvola.',
        serviceVoucherLink:
          'https://kouvola.asiointi.fi/IMS/fi?REQUEST=Search,P%E4iv%E4hoitopalvelut',
        privateUnitInfo: (
          <span>
            Information om daghemmen hittar du{' '}
            <ExternalLink
              text="här."
              href="https://www.kouvola.fi/kasvu-ja-oppiminen/paivahoito-ja-varhaiskasvatus/paivakodit/"
              newTab
            />
          </span>
        ),
      },
      applications: {
        creation: {
          daycareInfo:
            'Med en ansökan om småbarnspedagogik ansöker du om en kommunal plats på daghem. Med samma ansökan kan du också ansöka om servicesedel för ett privat daghem eller familjedagvård.',
          preschoolInfo: (
            <>
              <P>
                Den avgiftsfria förskoleundervisningen omfattar fyra timmar per
                dag. Därutöver kan du ansöka om kompletterande, avgiftsbelagd
                småbarnspedagogik som ordnas före och efter förskoleundervisningen.
                Du kan också ansöka om servicesedel genom att välja önskad
                servicesedelenhet. Ansökan kan göras i samband med anmälan eller
                separat efter att undervisningen har börjat.
              </P>
            </>
          ) as unknown as string,
          transferApplicationInfo: {
            DAYCARE:
              'Barnet har redan en plats i Kouvola stads småbarnspedagogik. Med denna ansökan kan du ansöka om byte till en annan enhet som erbjuder småbarnspedagogik.',
          },
          applicationInfo: (
            <P>
              Ansökan kan ändras så länge den inte har tagits till behandling,
              det vill säga medan den har statusen ”skickad”. Därefter görs
              ändringar genom att kontakta småbarnspedagogikens servicerådgivning
              på varhaiskasvatus.palveluohjaus@kouvola.fi eller per telefon
              (040 483 1890, 040 483 2400 eller 040 489 9042). En inlämnad
              ansökan kan återkallas per e-post.
            </P>
          )
        },
        editor: {
          additionalDetails: {
            title: 'Övriga tilläggsuppgifter',
            otherInfoLabel: 'Tilläggsuppgifter om ansökan',
            otherInfoPlaceholder: 'Du kan ge närmare tilläggsuppgifter om ansökan',
            dietLabel: 'Specialkost',
            dietPlaceholder: 'Du kan ange barnets specialkost',
            dietInfo: (
              <>
                Specialkost ska anmälas elektroniskt eller på papper. Kost av
                medicinska skäl ska vara konstaterad av hälso- och sjukvården,
                men något separat intyg behöver inte lämnas in.
              </>
            ) as React.ReactNode,
            allergiesLabel: 'Allergier',
            allergiesPlaceholder: 'Du kan ange barnets allergier'
          },
          serviceNeed: {
            shiftCare: {
              label: 'Kvälls- och skiftomsorg',
              instructions:
                'Skiftomsorg avser småbarnspedagogik som behövs på veckoslut eller dygnet runt. Kvällsomsorg ordnas huvudsakligen utanför kl. 7.00–17.00 och på veckoslut.',
              attachmentsMessage: {
                DAYCARE: (
                  <P>
                    Kvälls- och skiftomsorg är avsedd för barn vars båda
                    föräldrar arbetar i skift eller studerar på kvällar eller
                    veckoslut. Bifoga arbetsgivarens eller läroanstaltens intyg
                    för båda föräldrarna. Bilagor kan också föras till ett
                    daghem, stadshusets infopunkt eller postlådan vid H-dörren
                    (Torikatu 10, 45100 Kouvola).
                  </P>
                ),
                PRESCHOOL: (
                  <>
                    <P>
                      Bifoga aktuella intyg för vårdnadshavarna i samma hushåll
                      över regelbundet skiftarbete eller heltidsstudier på kvällstid.
                    </P>
                    <P>
                      Kvälls- och skiftomsorg är avsedd för barn vars båda
                      föräldrar arbetar i skift eller studerar på kvällar eller
                      veckoslut. Bilagor kan också föras till ett daghem,
                      stadshusets infopunkt eller postlådan vid H-dörren.
                    </P>
                  </>
                )
              },
            },
            partTime: {
              true: 'Deltid',
              false: 'Heltid'
            },
            dailyTime: {
              instructions: {
                DAYCARE: 'Ange den tid då barnet vanligen behöver småbarnspedagogik. Tiden preciseras när småbarnspedagogiken börjar.',
                PRESCHOOL: 'Förskoleundervisning ordnas fyra timmar per dag. Ange barnets behov så att de fyra timmarna ingår. Om behovet varierar, beskriv det närmare i tilläggsuppgifterna.'
              },
              connectedDaycareInfo: (
                <>
                  <P>
                    Du kan ansöka om avgiftsbelagd småbarnspedagogik som
                    kompletterar förskoleundervisningen. Den ordnas före och
                    efter förskoleundervisningen enligt enhetens öppettider.
                  </P>
                  <P>Du får ett separat skriftligt beslut om platsen.</P>
                </>
              ),
            },
          },
          contactInfo: {
            futureAddressInfo:
              'Kouvola småbarnspedagogik betraktar adressen i befolkningsdatabasen som den officiella adressen. Adressen ändras i befolkningsregistret när du gör en flyttanmälan till posten eller magistraten.',
          },
        },
      },
      decisions: {
        assistancePreschoolDecisions: {
          appealInstructions: (
            <>
              <P>
                Den som är missnöjd med beslutet kan lämna in en skriftlig
                begäran om omprövning. Beslutet får inte överklagas genom besvär
                hos domstol.
              </P>
              <H3>Rätt att begära omprövning</H3>
              <P>
                Omprövning får begäras av den som beslutet gäller eller vars
                rätt, skyldighet eller fördel direkt påverkas av beslutet.
              </P>
              <H3>Tid för begäran om omprövning</H3>
              <P>
                Begäran ska göras inom 30 dagar från delfåendet och lämnas till
                Kouvola stads registratorskontor före utgången av dess öppettid
                den sista dagen av tidsfristen.
              </P>
              <H3>Omprövningsmyndighet</H3>
              <P>
                Begäran riktas till Kouvola stads bildningsnämnd.
                <br />
                Postadress: PB 133, 87101 Kouvola
                <br />
                Besöksadress: Pohjolankatu 13, 87100 Kouvola
                <br />
                E-post: kouvola@kouvola.fi
                <br />
                Telefon: 08 61551
              </P>
              <H3>Begärans form och innehåll</H3>
              <P>
                Begäran ska göras skriftligen och ange beslutet, den ändring som
                yrkas, grunderna för yrkandet samt sökandens kontaktuppgifter.
                Bifoga beslutet med anvisningar, en utredning om tidpunkten för
                delfåendet och de handlingar som åberopas.
              </P>
            </>
          )
        },
        assistanceDecisions: {
          decision: {
            appealInstructions: (
              <>
                <H3>Rätt att begära omprövning</H3>
                <P>
                  Omprövning får begäras av den som beslutet gäller eller vars
                  rätt, skyldighet eller fördel direkt påverkas av beslutet.
                </P>
                <H3>Tid för begäran om omprövning</H3>
                <P>
                  Begäran ska lämnas till Regionförvaltningsverket i Norra
                  Finland inom 14 dagar från delfåendet.
                </P>
                <H3>Delfående</H3>
                <P>
                  Ett brev anses delgivet sju dagar efter att det skickades och
                  ett vanligt elektroniskt meddelande den tredje dagen efter
                  avsändandet. Dagen för delfåendet räknas inte in i tidsfristen.
                </P>
                <H3>Omprövningsmyndighet</H3>
                <P>
                  Regionförvaltningsverket i Norra Finland
                  <br />
                  Postadress: PB 6, 13035 AVI
                  <br />
                  Besöksadress: Linnankatu 3, Oulu
                  <br />
                  E-post: kirjaamo.pohjois@avi.fi
                  <br />
                  Telefon: 0295 016 000
                </P>
                <H3>Begärans form och innehåll</H3>
                <P>
                  Begäran ska göras skriftligen och ange beslutet, den ändring
                  som yrkas, grunderna och sökandens kontaktuppgifter. Bifoga
                  beslutet med anvisningar, en utredning om delfåendet och de
                  handlingar som åberopas.
                </P>
                <H3>Protokoll</H3>
                <P>
                  Protokollsutdrag och bilagor kan begäras från Kouvola stads
                  registratorskontor: PB 133, 87101 Kouvola, Pohjolankatu 13,
                  kouvola@kouvola.fi, telefon 08 61551.
                </P>
              </>
            )
          },
        }
      },
      income: {
        description: (
          <>
            <P>
              På den här sidan kan du lämna in en utredning över dina och dina
              barns inkomster som påverkar avgiften för småbarnspedagogik. Du kan
              granska, ändra eller radera utredningar tills de har behandlats.
              Efter behandlingen uppdaterar du uppgifterna med en ny blankett.
            </P>
            <P>
              Klientavgiften bestäms utifrån familjens bruttoinkomster, storlek
              och tiden inom småbarnspedagogiken. Inkomstuppgifterna ska lämnas
              senast en månad efter att småbarnspedagogiken börjat. Utan en
              inkomstutredning fastställs den högsta avgiften.
            </P>
            <P>
              Mer information finns på{' '}
              <a href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/">
                Avgifter inom småbarnspedagogiken
              </a>
            </P>
          </>
        ),
        formDescription: (
          <>
            <P>
              Inkomstutredningen med bilagor ska lämnas inom en månad efter att
              småbarnspedagogiken börjat. Bristfälliga uppgifter kan leda till
              den högsta avgiften och rättas inte retroaktivt efter tiden för
              omprövning. Meddela utan dröjsmål förändringar i inkomster och
              familjestorlek. Om inkomsterna överstiger gränsen kan du godkänna
              den högsta avgiften utan att lämna in inkomstuppgifter. En annan
              vuxen i familjen ska lämna sin egen utredning i eVaka.
            </P>
            <P>* Uppgifter markerade med en stjärna är obligatoriska</P>
          </>
        ),
        assure: <>Jag försäkrar att uppgifterna är riktiga och att jag har tagit del av Kouvola stads grunder för fastställande av avgiften: kouvola.fi/varhaiskasvatusmaksut *</>,
        grossIncome: {
          estimatedMonthlyIncome: 'Genomsnittliga inkomster inklusive semesterpenning, €/mån. En egen uppskattning räcker inte; bifoga ett inkomstintyg.',
          description: (
            <>
              <P noMargin>
                Välj om du lämnar in inkomstuppgifterna som bilagor eller om
                myndigheten vid behov hämtar dem ur inkomstregistret och från
                FPA. Om du förbjuder användningen av inkomstregistret, ange det
                i tilläggsuppgifterna.
              </P>
            </>
          ),
          incomesRegisterConsent: 'Jag godkänner att mina inkomstuppgifter vid behov kontrolleras i inkomstregistret och hos FPA',
          noIncome: 'Jag har inga inkomster eller stöd. Mina uppgifter får kontrolleras i inkomstregistret och hos FPA',
        },
        entrepreneurIncome: {
          checkupConsent: 'Jag godkänner att mina inkomstuppgifter vid behov kontrolleras i inkomstregistret och hos FPA',
        },
        limitedCompany: {
          incomesRegister: 'Mina inkomster får vid behov kontrolleras i inkomstregistret och hos FPA',
        },
        view: {
          incomesRegister: 'Jag godkänner att mina inkomstuppgifter vid behov kontrolleras i inkomstregistret och hos FPA',
          noIncomeTitle: 'Jag har inga inkomster eller stöd. Mina uppgifter får kontrolleras i inkomstregistret och hos FPA',
          checkupConsent: 'Jag godkänner att mina inkomstuppgifter vid behov kontrolleras i inkomstregistret och hos FPA',
          limitedCompanyIncomesRegister: 'Mina inkomster får vid behov kontrolleras hos FPA eller i inkomstregistret.',
        }
      },
      accessibilityStatement: (
        <>
          <H1>Tillgänglighetsutlåtande</H1>
          <P>
            Detta tillgänglighetsutlåtande gäller Kouvola stads webbtjänst eVaka för
            småbarnspedagogiken på adressen{' '}
            <a href="https://varhaiskasvatus.kouvola.fi">varhaiskasvatus.kouvola.fi</a>.
            Kouvola stad strävar efter att säkerställa webbtjänstens tillgänglighet,
            kontinuerligt förbättra användarupplevelsen och att tillämpa lämpliga
            tillgänglighetsstandarder.
          </P>
          <P>
            Tjänstens tillgänglighet har bedömts av tjänsteutvecklingsteamet, och
            utlåtandet har utarbetats den 12 april 2022.
          </P>
          <H2>Tjänstens överensstämmelse med krav</H2>
          <P>
            Webbtjänsten uppfyller de lagstadgade kritiska tillgänglighetskraven
            enligt nivå AA i WCAG 2.1. Tjänsten uppfyller ännu inte alla krav.
          </P>
          <H2>Åtgärder för att stödja tillgängligheten</H2>
          <P>
            Webbtjänstens tillgänglighet säkerställs bland annat genom följande
            åtgärder:
          </P>
          <ul>
            <li>
              Tillgängligheten beaktas redan från början i planeringsfasen till
              exempel genom att välja färgerna och fontstorleken i tjänsten med
              tillgängligheten i åtanke.
            </li>
            <li>Elementen i tjänsten har definierats semantiskt konsekvent.</li>
            <li>Tjänsten testas ständigt med en skärmläsare.</li>
            <li>
              Olika användare testar tjänsten och ger respons på tillgängligheten.
            </li>
            <li>
              Webbplatsens tillgänglighet säkerställs genom kontinuerliga kontroller
              vid tekniska eller innehållsmässiga förändringar.
            </li>
          </ul>
          <P>
            Detta utlåtande uppdateras när webbplatsen ändras eller tillgängligheten
            justeras.
          </P>
          <H2>Kända tillgänglighetsproblem</H2>
          <P>
            Användare kan fortfarande stöta på vissa problem på webbplatsen. Nedan
            följer beskrivningar av kända tillgänglighetsproblem. Om du upptäcker
            ett problem som inte finns med på listan, vänligen kontakta oss.
          </P>
          <ul>
            <li>
              Tjänstens datum- och flervalsfält är inte optimerade för att användas
              med skärmläsare
            </li>
            <li>
              Det går inte att navigera på serviceenhetskartan med
              tangentbordet/skärmläsaren, men man kan bläddra bland enheterna på
              listan i samma vy. Kartan som används i tjänsten är framtagen av en
              tredje part.
            </li>
          </ul>
          <H2>Tredje parter</H2>
          <P>
            Webbtjänsten använder följande tredjepartstjänster, vars tillgänglighet
            vi inte är ansvariga för.
          </P>
          <ul>
            <li>Användarautentiseringstjänsten Keycloak</li>
            <li>Tjänsten suomi.fi</li>
            <li>Karttjänsten Leaflet</li>
          </ul>
          <H2>Ge respons</H2>
          <P>
            er en tillgänglighetsbrist i vår webbtjänst, vänligen meddela oss. Du
            kan ge respons med{' '}
            <ExternalLink
              href="https://kouvola.asiointi.fi/eFeedback"
              text="webformuläret"
            />
          </P>
          <H2>Tillsynsmyndighet</H2>
          <P>
            Om du upptäcker tillgänglighetsproblem på webbplatsen, ge först respons
            till oss, webbplatsens administratörer. Det kan ta upp till 14 dagar
            tills du får ett svar från oss. Om du inte är nöjd med det svar du har
            fått eller om du inte alls har fått något svar inom två veckor, kan du
            ge respons till Regionförvaltningsverket i Södra Finland. På
            regionförvaltningsverkets webbplats finns information om hur du kan
            lämna in ett klagomål samt om hur ärendet handläggs.
          </P>
          <P>
            <strong>Kontaktuppgifter till tillsynsmyndigheten</strong>
            <br />
            Transport- och kommunikationsverket Traficom
            Enheten för tillsyn över digital tillgänglighet
            www.tillganglighetskrav.fi
            tillganglighet(at)traficom.fi
            telefonnummer växeln 029 534 5000
          </P>
        </>
      ),
    },
    en: {
      header: {
        lang: {
          fi: 'Suomeksi',
          sv: '',
          en: 'In English'
        },
        langMobile: {
          fi: 'Suomeksi',
          sv: '',
          en: 'English'
        },
      },
      footer: {
        cityLabel: '© City of kouvola',
        privacyPolicyLink: (
          <a
            href="https://kouvola.asiointi.fi/eFeedback/en/PrivacyPolicy"
            data-qa="footer-policy-link"
            style={{ color: colors.main.m2 }}
          >
            Privacy notices
          </a>
        ),
        sendFeedbackLink: (
          <a
            href="https://kouvola.asiointi.fi/eFeedback/en"
            data-qa="footer-feedback-link"
            style={{ color: colors.main.m2 }}
          >
            Give feedback
          </a>
        ),
      },
      calendar: {
        absentPlanned: 'Announced absence',
      },
      children: {
        serviceApplication: {
            serviceNeedInfo:
              'You can choose from the following service needs. If you wish to change to another service need, please contact the staff. Service need must be selected to start of a month. If your income has changed, write it down below and create a new income statement.',
            additionalInfo: 'Additional information',
            additionalInfoInfo:
              'Type additional information here, e.g., why you want to change service need.',
          },
      },
      loginPage: {
        title: 'City of kouvola early childhood education',
        login: {
          infoBoxText: (
            <>
              <P>
                If login doesn't work, please contact {' '}
                <a href="mailto:evakatuki@kouvola.fi">evakatuki@kouvola.fi</a>
                You can also log in using strong authentication.
              </P>
            </>
          ),
        },
      },
      map: {
        mainInfo:
          "In this view, you can search the map for Kouvola's early childhood education, pre-primary education and club places.",
        serviceVoucherLink:
          'https://kouvola.asiointi.fi/IMS/fi?REQUEST=Search,P%E4iv%E4hoitopalvelut',
        privateUnitInfo: (
          <span>
            Information about daycares can be found{' '}
            <ExternalLink
              text="here."
              href="https://www.kouvola.fi/kasvu-ja-oppiminen/paivahoito-ja-varhaiskasvatus/paivakodit/"
              newTab
            />
          </span>
        ),
      },
      applicationsList: {
        title:
          'Applying for early childhood education or a club and enrolling for pre-primary education',
        summary: (
          <P width="800px">
            A child’s guardian can submit an application for early childhood
            education or enroll the child to pre-primary education. You
            can also use the same application to apply for a service voucher for
            early childhood education. To do this, you have to apply for a place in
            early childhood education at a service voucher unit. Information on the
            guardian’s children is automatically retrieved from the Digital and
            Population Data Services Agency and displayed in this view.
          </P>
        ),
        pageLoadError: 'Failed to load guardian applications',
        type: {
          DAYCARE: 'Application for early childhood education',
          PRESCHOOL: 'Pre-primary education application',
          CLUB: 'Club application (not in use)'
        },
      },
      applications: {
        creation: {
          preschoolInfo:
            'There are four hours of free preschool education per day. In addition, a child can apply for supplementary paid early childhood education, which is offered at preschool places in the morning before the start of preschool education and in the afternoon after preschool education. You can also apply for a service voucher for supplementary early childhood education by selecting the service voucher unit you wish to apply for in the Application Preferences section. You can apply for supplementary early childhood education when registering for preschool education or as a separate application after education has already started.',
          transferApplicationInfo: {
            DAYCARE:
              "Your child already has a place in the City of Kouvola's early childhood education. Use this application to apply for a transfer to another early childhood education unit.",
          },
          applicationInfo: (
            <P>
              As long as the application has not been accepted,
              you can make changes to the application. After that,
              changes to the application are made by contacting
              the language and culture coordinator for early childhood education and care.
            </P>
          )
        },
        editor: {
          additionalDetails: {
              dietInfo: (
                <>
                  Some special diets require a separate medical certificate to be delivered to the early childhood
                  education location. Exceptions are a low-lactose or lactose-free diet, a diet based on religious
                  beliefs and vegetarian diet (lacto-ovo).
                </>
            ),
          },
          unitPreference: {
            units: {
              serviceVoucherLink:
              'https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/yksityinen-varhaiskasvatus/varhaiskasvatuksen-palveluseteli/',
            },
            siblingBasis: {
              title: 'Application on a sibling basis',
              info: {
                DAYCARE: (
                  <>
                    <P>
                      The sibling principle applies if you apply for a place in an
                      early childhood education unit in which the child’s sibling
                      has a place when early childhood education starts. All
                      children living at the same address are considered to be
                      siblings. The aim is to place siblings at the same early
                      childhood education place, if the family so wishes. If you are
                      applying for places for siblings who do not yet attend early
                      childhood education, enter this piece of information in the
                      additional information field.
                    </P>
                    <P>
                      Fill in this information only if you want to exercise the
                      sibling-basis right.
                    </P>
                  </>
                ),
                PRESCHOOL: (
                  <>
                    <ol>
                      <li>
                        A child enrolling for pre-primary education has a
                        sibling-basis right to a early childhood education, where
                        they have a sibling who has, at the moment of making the
                        decision and in the coming pre-primary education year, a
                        place at the pre-primary education unit.
                      </li>
                    </ol>
                    <P>
                      If the child enrolling for pre-primary education has a
                      sibling-basis right to both options, the guardian may decide
                      which of them will be exercised. The selection is indicated by
                      entering the name of the sibling in the field below.
                    </P>
                    <P>
                      Fill in this information only if you want to exercise the
                      sibling-basis right.
                    </P>
                  </>
                ),
              },
            },
          },
          heading: {
            info: {
              DAYCARE: (
                <>
                  <P>
                    You can apply for early childhood education all year round. The
                    application must be submitted at the latest four months before
                    the need for early childhood education begins. If you urgently
                    need early childhood education, you must apply for a place at
                    the latest two weeks before the need begins.
                  </P>
                  <P>
                    The applicant will receive a written decision on the early
                    childhood education place via the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Messages service of Suomi.fi
                    </a>{' '}
                    or by post if the applicant has not taken in use the Messages
                    service of Suomi.fi.
                  </P>
                  <P>
                    The client fees for municipal early childhood education and the
                    client charges for service voucher users are calculated as a
                    percentage of the family’s gross income. The fees vary depending
                    on the family’s size and the hours of early childhood education.
                    Service voucher units may charge an additional monthly fee,
                    information of the possible additional fee can be found from
                    units own website. Each family must provide information about
                    their gross income, no later than two weeks after their child’s
                    early childhood education has started.
                  </P>
                  <P>
                    For more information on early childhood education and care fees,
                    how to submit a performance report and the service voucher surcharge, click here:
                    <a href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/">
                    early childhood education and care fees
                    </a>
                    .
                  </P>
                  <P fitted={true}>* Tähdellä merkityt tiedot ovat pakollisia</P>
                </>
              ),
              PRESCHOOL: (
                <>
                  <P>
                  Pre-school education is attended in the year before compulsory education. {' '}
                  Pre-school education is free of charge.
                  </P>
                  <P>
                    The decisions will be sent to the{' '}
                    <a
                    href="https://www.suomi.fi/messages"
                    target="_blank"
                    rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                      service or by post, if the applicant does not use the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                    service.
                  </P>
                  <P>
                    If you need early childhood education before the start of preschool, you can apply for it with this application by selecting "additional early childhood education".
                  </P>
                  <P fitted={true}>* Information marked with a star is required</P>
                </>
              ),
              CLUB: (
                <>
                  <P>
                    Applications for playgroup activities are made electronically with an application form
                    for early childhood education. In the application form, you select part-day care as the
                    type of care and write in the additional information that you are applying for playgroup activities.
                  </P>
                  <P>
                    The playgroup fee is 17% of the Early Childhood Education and Care fee,
                    which is calculated from family’s income and size.
                  </P>
                  <P>
                    Playgroup activities are active from September to the end of May.
                    Kids can attend Playgroup activities from the begining of the month in which the child turns 3 years old.
                  </P>
                  <P fitted={true}>* Information marked with an asterisk is required</P>
                </>
              )
            },
          },
          actions: {
            allowOtherGuardianAccess: (
              <span>
                I understand that the application will also be visible to the other
                guardian. If the other guardian should not be able to see this
                application, please contact the Early Childhood Education Service
                Guidance, whose contact information can be found{' '}
                <a
                  href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/"
                  target="_blank"
                  rel="noreferrer"
                >
                  here
                </a>
                .
              </span>
            ),
          },
          serviceNeed: {
            shiftCare: {
             instructions:
              'Round-the-clock care refers to early childhood education needed on weekends or around the clock. Evening and round-the-clock care is mainly early childhood education taking place outside the weekday hours of 7:00 and 17:00.',
              attachmentsMessage: {
                DAYCARE: (
                <P>
                  Evening and round-the-clock care is intended for children whose
                  both parents do shift work or mainly study in the evening and/or
                  during the weekends. In addition to the application, both
                  parents will need to provide a document issued by their employer
                  concerning shift work or a document concerning their studies as
                  proof of the child’s need for evening or round-the-clock care.
                  We recommend that you send the additional documents through this
                  online system. If you cannot add attachments to the application electronically,
                  you can bring them to any daycare center, the information point at the
                  City Hall, or the mailbox located at H-door (address: Torikatu 10, 45100 Kouvola).
                </P>
              ),
              PRESCHOOL: (
                <>
                  <P>
                    If a guardian living in the same household does regular shift
                    work or attends evening studies full-time, they must provide
                    proof of this (a document issued by their employer or the
                    educational institution) together with the application for
                    pre-primary education. The documents must be dated in the year
                    when the application for pre-primary education is submitted.
                  </P>
                  <P>
                    Evening and round-the-clock care is intended for children
                    whose both parents do shift work or mainly study in the
                    evening and/or during the weekends. In addition to the
                    application, both parents will need to provide a document
                    issued by their employer concerning shift work or a document
                    concerning their studies as proof of the child’s need for
                    evening or round-the-clock care. We recommend that you send
                    the additional documents through this online system.
                    If you cannot add attachments to the application electronically,
                    you can bring them to any daycare center, the information point
                    at the City Hall, or the mailbox located at H-door
                    (address: Torikatu 10, 45100 Kouvola).
                  </P>
                </>
                )
              },
            },
            startDate: {
              instructions: {
                DAYCARE: (
                  <>
                    You can postpone your desired start date until the processing of
                    your application starts. After this, you can make changes to
                    your desired start date by contacting early childhood education
                    service counselling varhaiskasvatus.palveluohjaus@kouvola.fi or
                    (phone. 0404831890, 0404832400 tai 0404899042)
                  </>
                ),
                PRESCHOOL: (
                  <>
                    You can postpone your desired start date until the processing of
                    your application starts. After this, you can make changes to
                    your desired start date by contacting early childhood education
                    service counselling  varhaiskasvatus.palveluohjaus@kouvola.fi or
                    (phone. 0404831890, 0404832400 tai 0404899042)
                  </>
                ),
                CLUB: null
              },
              info: {
                PRESCHOOL: [
                  <>
                    <P>
                      Pre-school education is attended in the year before compulsory education starts.
                      Pre-school education is free of charge. For more information:{' '}
                      <a href='https://www.kouvola.fi/kasvu-ja-oppiminen/esiopetus/'>https://www.kouvola.fi/kasvu-ja-oppiminen/esiopetus/</a>
                    </P>
                  </> as unknown as string
                ],
              },
            },
            urgent: {
              attachmentsMessage: {
                text: (
                  <P fitted={true}>
                    If the need for a place in early childhood education arises from
                    sudden employment or a sudden start of studies, you will need to
                    apply for a place no later than{' '}
                    <strong>two weeks before</strong> your child needs it. In
                    addition to the application, you will need to{' '}
                    <strong>
                      provide documents as proof of the employment or student status
                    </strong>{' '}
                    of both guardians living in the same household.
                    If you cannot add attachments to the application electronically,
                    you can bring them to any daycare center, the information point at the
                    City Hall, or the mailbox located at H-door (address: Torikatu 10, 45100 Kouvola).
                  </P>
                ),
              }
            },
            dailyTime: {
              instructions: {
                PRESCHOOL:
                  'The preschool education is provided in both early childhood education units and schools for 4 hours a day, but the hours may vary by unit. Indicate the  early childhood education hours needed by the child so that it includes  the 4 hours of pre-primary education (e.g. 7:00–17:00). The hours will  be specified when early childhood education begins. If the hours of  early childhood education need to vary daily or weekly (e.g. in  round-the-clock care), please specify the need in the additional information field.'
              },
              connectedDaycareInfo: (
                <>
                  <P>
                    You can apply for your child early childhood education related to preschool education, which is subject to a charge.
                    Related early childhood education is provided in the mornings before preschool education and in the afternoons after preschool
                    education in accordance with the opening hours of the preschool education unit.
                  </P>
                  <P>
                    A separate written decision will be issued on the early
                    childhood education place. The decision will be sent to the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi Messages
                    </a>{' '}
                    service or by post if you do not use the{' '}
                    <a
                      href="https://www.suomi.fi/messages"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Suomi.fi messages
                    </a>{' '}
                    service.
                  </P>
                </>
              ),
            },
          },
          fee: {
            links: (
              <>
              <P>
                You can find further information about early childhood education
                fees, additional fees for service voucher users and the income
                statement form here:
                <br />
                <a
                  href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Early childhood education fees
                </a>
              </P>
              <P>
                <a
                  href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/yksityinen-varhaiskasvatus/varhaiskasvatuksen-palveluseteli/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Additional fees for service voucher users
                </a>
              </P>
              </>
            )
          },
          contactInfo: {
            futureAddressInfo:
              "kouvola's early childhood education considers the address retrieved from the Population Register Centre as the official address. The address in the Population Register Centre changes when the applicant makes a notification of move to Posti or the Local Register Office.",
          },
        },
      },
      income: {
        description: (
          <>
           <P>
             On this page, you can submit statements on your and your
             children&apos;s earnings that affect the early childhood education
             fee. You can also view, edit, or delete income statements that you
             have submitted until the authority has processed the information.
             After the form has been processed, you can update your income
             information by submitting a new form.
           </P>
           <P>
             The client fees for municipal early childhood education are determined
             as a percentage of the family’s gross income. The fees vary according
             to family size, income and time in early childhood education.
             For the purposes of determining the fee,
             the family's informations of incomes must be submitted within two weeks
             of the start of the early childhood education and care.
             If the family fails to provide income information, the maximum fee will be imposed.
           </P>
           <P>
             More information on the fees:{' '}
             <a href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/">
               Early childhood education fees
             </a>
           </P>
         </>
        ),
        formDescription: (
          <>
            <P>
              The income statement and attachments must be returned within one month of starting early childhood education. The payment may be set at the highest payment due to incomplete income information.
              Incomplete income information cannot be corrected retroactively after the correction period. The client fee is collected from the date of commencement of early childhood education according to the decision.
              The client must immediately notify the administrative secretary of early childhood education of changes in income and the early childhood education unit of changes in family size. If necessary, the authority is entitled to collect early childhood education fees also retroactively.

              Please note:
              If your income exceeds the income limit for the highest payment according to family size, accept the highest early childhood education fee. In this case, you do not need to determine your income at all.
              If there is another adult in your family, they must also submit an income statement by identifying themselves in eVaka with their own personal information and filling out this form.
              You can also report both of yours incomes if you wish. In this case, the administrative secretary will enter the income information on behalf of the other guardian. Income information must be submitted yourself and checked from the Incomes Register if necessary.
              See the current income limits here: kouvola.fi/varhaiskasvatusmaksu/
            </P>
            <P>
              For more information on the fees: {' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.kouvola.fi/kasvatus-ja-koulutus/varhaiskasvatus-ja-esiopetus/varhaiskasvatuksen-asiakasmaksut/"
              >
                here
              </a>
              .
            </P>
            <P>* The information denoted with an asterisk is mandatory.</P>

          </>
        ),
        assure: <>I declare that the information I have provided is correct and that I have read the City of Kouvola's fee determination criteria: kouvola.fi/varhaiskasvatusmaksut *</>,
      },
      accessibilityStatement: (
        <>
          <H1>Accessibility statement</H1>
          <P>
            This accessibility statement applies to the City of kouvola's early
            childhood education online service eVaka at{' '}
            <a href="https://varhaiskasvatus.kouvola.fi">varhaiskasvatus.kouvola.fi</a>.
            The City of kouvola endeavours to ensure the accessibility of the online
            service, continuously improve the user experience and apply appropriate
            accessibility standards.
          </P>
          <P>
            The accessibility of the service was assessed by the development team of
            the service, and this statement was drawn up on 12 April 2022.
          </P>
          <H2>Compliance of the service</H2>
          <P>
            The online service complies with the statutory critical accessibility
            requirements in accordance with Level AA of the Accessibility Guidelines
            for the WCAG v2.1. The service is not yet fully compliant with the
            requirements.
          </P>
          <H2>Measures to support accessibility</H2>
          <P>
            The accessibility of the online service is ensured, among other things,
            by the following measures:
          </P>
          <ul>
            <li>
              Accessibility has been taken into account from the beginning of the
              design phase, for example, when choosing the colours and font sizes of
              the service.
            </li>
            <li>
              The service elements have been defined in consistently in terms of
              semantics.
            </li>
            <li>The service is continuously tested with a screen reader.</li>
            <li>
              Various users test the service and give feedback on its accessibility.
            </li>
            <li>
              When website technology or content changes, its accessibility is
              ensured through constant monitoring.
            </li>
          </ul>
          <P>
            This statement will be updated in conjunction with website changes and
            accessibility evaluations.
          </P>
          <H2>Known accessibility issues</H2>
          <P>
            Users may still encounter some issues on the website. The following
            contains a description of known accessibility issues. If you notice an
            issue on the site that is not listed, please contact us.
          </P>
          <ul>
            <li>
              Date pickers and multi-select dropdowns in the service are not
              optimised to be used with a screen reader.
            </li>
            <li>
              The service's unit map cannot be navigated using the keyboard/screen
              reader, but the units can be browsed on the list available in the same
              view. The map used in the service is produced by a third party.
            </li>
          </ul>
          <H2>Third parties</H2>
          <P>
            The online service uses the following third party services, the
            accessibility of which we cannot be responsible for.
          </P>
          <ul>
            <li>Keycloak user identification service</li>
            <li>Suomi.fi identification</li>
            <li>Leaflet map service</li>
          </ul>
          <H2>Alternative ways of accessing the service</H2>
          <P>
            <ExternalLink
              href="https://www.kouvola.fi/toimipisteet"
              text="The City of kouvola’s Service Points"
            />{' '}
            provide assistance with using electronic services. Service advisors at
            the Service Points help users who cannot access digital services or
            send us email varhaiskasvatus.palveluohjaus@kouvola.fi
          </P>
          <H2>Give feedback</H2>
          <P>
            If you notice an accessibility gap in our online service, please let us
            know! You can give us feedback using the{' '}
            <ExternalLink
              href="https://kouvola.asiointi.fi/eFeedback/en/Feedback/20"
              text="online form"
            />{' '}
            or by emailing{' '}
            <a href="mailto:palaute@kouvola.fi"> palaute@kouvola.fi</a>.
          </P>
          <H2>Supervisory authority</H2>
          <P>
            If you notice any accessibility issues on the website, please send us,
            the site administrator, feedback first. It may take us up to 14 days to
            reply. If you are not satisfied with the reply or you do not receive a
            reply within two weeks, you can give feedback to the Regional State
            Administrative Agency for Southern Finland. The website of the Regional
            State Administrative Agency for Southern Finland explains in detail how
            a complaint can be submitted, and how the matter will be processed.
          </P>
          <P>
            <strong>Contact information of the supervisory authority</strong>
            <br />
            Regional State Administrative Agency of Southern Finland
            <br />
            Accessibility Supervision Unit
            <br />
            <ExternalLink
              href="https://www.saavutettavuusvaatimukset.fi"
              text="www.saavutettavuusvaatimukset.fi"
            />
            <br />
            <a href="mailto:saavutettavuus@avi.fi">saavutettavuus@avi.fi</a>
            <br />
            tel. (exchange) 0295 016 000
            <br />
            Open: Mon-Fri 8.00–16.15
          </P>
        </>
      ),
    },
  },
  cityLogo: {
    src: MunicipalityLogo,
    alt: 'kouvola logo',
  },
  routeLinkRootUrl: 'https://reittiopas.hsl.fi/reitti/',
  mapConfig,
  featureFlags,
  getMaxPreferredUnits() {
    return 3
  },
}

export default customizations
